import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import LazyLoad from 'react-lazy-load';

import { Divider, LText, Button, Spacer } from '@lafabrica/core';
import { DownArrow } from '../DownArrow';

const Wrapper = styled.div`
  min-height: calc(100vh - ${props => props.includeBanner ? 80 : 50}px);
  height: auto;
  width: 100vw;
  display: flex;
  flex-direction: row;
  padding-top: ${props => props.includeBanner ? 80 : 50}px;

  @media only screen and (min-width: 769px) {
    min-height: calc(100vh - ${props => props.includeBanner ? 130 : 80}px);
    padding-top: ${props => props.includeBanner ? 130 : 80}px;
  }
`;

const Side = styled.div`
  width: 100vw;
  height: calc(100vh - ${props => props.includeBanner ? 80 : 50}px);
  max-height: 600px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;

  @media only screen and (min-width: 769px) {
    width: 50vw;
    height: calc(100vh - ${props => props.includeBanner ? 130 : 80}px);
    max-height: none;
    text-align: inherit;
  }
`;

const LeftSide = styled(Side)`
  @media only screen and (min-width: 769px) {
    min-width: 620px;
  }
`;

const RightSide = styled(Side)`
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media only screen and (min-width: 769px) {
    height: auto;
    background-position: center;
  }
`

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: var(--accent);
  opacity: 0.15;
`

const TextWrapper = styled.div`
  padding: 0 20px;

  @media only screen and (min-width: 769px) {
    padding: 0 40px;
    width: 620px;
  }
`;

const InsetImage = styled.img`
  max-width: 60%;
  max-height: 600px;
  margin: auto;
`

const DownArrowContainer = styled.div`
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-items: center;
`

export const OpeningPanel = ({textChildren, includeBanner, backgroundImage, backgroundStyle={}, insetImage, insetImageStyle={}, transparentHeader, setShowModal = f => f, overlay=true, hideRightSideMobile=false, flip=false, showDownArrow=false, rightSideChildren=null}) => {

  const coreHeight = isMobile ? 50 : 80
  const wrapperAdjustment = coreHeight + includeBanner ? 50 : 0 + transparentHeader ? -coreHeight : 0;

  return (
    <Wrapper style={isMobile ? {flexDirection: 'column'} : {}}>
      { !flip &&
        <LeftSide>
          <TextWrapper>
            {textChildren}
          </TextWrapper>
        </LeftSide>
      }
      {(!hideRightSideMobile || !isMobile) &&
        <RightSide style={
          backgroundImage ? {background: `var(--light-black) url(${backgroundImage}) no-repeat center`, ...backgroundStyle} :
          {}}>
          {insetImage && <LazyLoad><InsetImage src={insetImage} style={insetImageStyle} /></LazyLoad>}
          {overlay && <Overlay />}
          {rightSideChildren}
        </RightSide>
      }
      { flip &&
        <LeftSide>
          <TextWrapper>
            {textChildren}
          </TextWrapper>
        </LeftSide>
      }
      {showDownArrow &&
        <DownArrowContainer>
          <DownArrow color={"var(--black)"}/>
        </DownArrowContainer>
      }
    </Wrapper>
  );
};
